import { getNavigation, NavAuth, routes } from '~/navigation';
import { Permission, Resource, useViewer } from './useViewer';
import log from '~/log';

export function useNavigation() {
    const viewer = useViewer();
    const onlyShowOwnEvents = viewer.hasPermission('additional.onlyShowOwnEvents', 'enabled');
    const appNavigation = getNavigation(routes);

    log.trace('viewer.appNavigation', appNavigation);

    const navigation = appNavigation
        .map((nav) => {
            let children = nav.children?.filter((child: NavAuth) => {
                const { resource, permission = 'view' } = child.auth || {};
                return viewer.hasPermission(resource as Resource, permission as Permission);
            });

            if (onlyShowOwnEvents) {
                children = children?.map((child: NavAuth) => {
                    return child?.label === 'Terminplan'
                        ? { ...child, to: `/projekte/termine/person` }
                        : child;
                });
            }

            return {
                ...nav,
                children,
            };
        })
        .filter((nav) => nav.children === undefined || (nav.children && nav.children?.length > 0));

    log.trace('viewer.navigation', navigation);

    return navigation;
}
